import styled from "@emotion/styled"
import { DataGrid, ptBR, DataGridProps, GridToolbar } from "@mui/x-data-grid"

const StyledGrid = styled(DataGrid)`
    .MuiDataGrid-virtualScroller {
        min-height: 52px;
    }

    .row-color-danger {
        background-color: rgba(255, 0, 0, 0.2);
        
        :hover {
            background-color: rgba(255, 0, 0, 0.3);
        }
    }
`

export const Table = (props: DataGridProps) => {
    return (
        <StyledGrid
            localeText={{
                ...ptBR.components.MuiDataGrid.defaultProps.localeText,
                noRowsLabel: 'Não há registros'
            }}
            slots={{
                toolbar: GridToolbar,
            }}
            rowSelection={false}
            {...props}
        />
    )
}
